<template>
  <div>
    <a-card title="流程列表" class="filter-data">
      <span slot="extra">
        <a-button class="handle-menu" type="primary" icon="plus" @click="onAdd">添加流程</a-button>
      </span>
      <a-table :show-header="false" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handlePageChange">
        <span slot="action" slot-scope="text, record">
          <a class="ant-dropdown-link" @click="onDetail(record)"> 查看 </a>
          <a-divider type="vertical" />
          <a-dropdown placement="bottomCenter">
            <a class="ant-dropdown-link" :disabled="!record.modify_permission || record.status.value !== 1"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onEdit(record)">编辑流程</a>
              </a-menu-item>
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onStop(record)">终止流程</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <span slot="avatar" slot-scope="text, record">
          <a-avatar shape="square" :size="48" icon="user" :src="record.creator.avatar_url" class="table-image" />
        </span>
        <span slot="titleCreator" slot-scope="text, record">
          <div>
            <span class="workflow-lable">流程标题:</span><span class="workflow-value">{{ record.title }}</span>
          </div>
          <div>
            <span class="workflow-lable">创建人员:</span><span class="workflow-value"><user-profiles :value="[record.creator.id]" /> </span>
          </div>
        </span>
        <span slot="templateType" slot-scope="text, record">
          <div>
            <span class="workflow-lable">流程模板:</span><span class="workflow-value">{{ record.template_name }}</span>
          </div>
          <div>
            <span class="workflow-lable">流程类型:</span><span class="workflow-value">{{ record.workflow_type.label }}</span>
          </div>
        </span>

        <span slot="statusStep" slot-scope="text, record">
          <div>
            <span class="workflow-lable">当前状态:</span>
            <span class="workflow-value">
              <a-badge :status="workflowStatus[record.status.value].status" :text="workflowStatus[record.status.value].label" />
            </span>
          </div>
          <div>
            <span class="workflow-lable">当前步骤:</span><span class="workflow-value">{{ record.step_name }}</span>
          </div>
        </span>
        <span slot="time" slot-scope="text, record">
          <div>
            <span class="workflow-lable">创建时间: </span><span class="workflow-value">{{ record.created_time }}</span>
          </div>
          <div>
            <span class="workflow-lable">更新时间: </span><span class="workflow-value">{{ record.updated_time }}</span>
          </div>
        </span>

        <span slot="progress" slot-scope="text, record">
          <a-progress stroke-linecap="round" :percent="record.progress" type="circle" :status="record.status.value === 3 ? 'exception' : null" :width="50" :stroke-width="11" />
        </span>
      </a-table>
    </a-card>
    <workflow-stop-modal ref="workflowStopModalRef" @ok="getWorkFlowList" />
    <workflow-modify-modal ref="workflowModifyModalRef" @ok="getWorkFlowList" />
  </div>
</template>
<script>
import WorkflowStopModal from '@/pages/project/workflow/components/WorkflowStopModal';
import WorkflowModifyModal from '@/pages/project/workflow/components/WorkflowModifyModal';
import { workflowStatus } from '@/utils/dictionary';
import { workflowList } from '@/api/project/workflow';

export default {
  components: { WorkflowStopModal, WorkflowModifyModal },
  data() {
    return {
      loading: false,
      workflowStatus,
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      workflowId: null,
      columns: [
        {
          title: '头像',
          width: 60,
          align: 'center',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          minWidth: 300,
          scopedSlots: { customRender: 'titleCreator' }
        },
        {
          width: 180,
          scopedSlots: { customRender: 'templateType' }
        },
        {
          width: 180,
          scopedSlots: { customRender: 'statusStep' }
        },
        {
          align: 'center',
          width: 240,
          scopedSlots: { customRender: 'time' }
        },
        {
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'progress' }
        },
        {
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tableData: []
    };
  },
  methods: {
    // 获取工作流列表
    getWorkFlowList() {
      this.loading = true;
      workflowList(this.filterForm)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 添加工作流
    onAdd() {
      this.$router.push({ name: 'page:project:workflow:create' });
    },

    /**
     * 终止工作流
     * @param {*} record
     */
    onEdit(record) {
      this.$nextTick(() => {
        this.$refs.workflowModifyModalRef.onOpen(record.id, record.project.id);
      });
    },
    /**
     * 编辑工作流
     * @param {*} record
     */
    onStop(record) {
      this.$nextTick(() => {
        this.$refs.workflowStopModalRef.onOpen(record.id, record.project.id);
      });
    },

    // 查看工作流详情
    onDetail(record) {
      this.$router.push({
        name: 'page:project:workflow:detail',
        query: {
          workflowId: record.id
        }
      });
    },

    // 页面变更
    handlePageChange(pagination) {
      this.pagination = pagination;
      const customerQuery = { ...this.$route.query };
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.$set(customerQuery, 'page_size', pagination.pageSize);
      this.$set(customerQuery, 'page_number', pagination.current);
      this.$router.push({ name: 'page:project:workflow:list', query: customerQuery });
      this.getWorkFlowList();
    },

    // 关闭弹框的回调
    close(type = 'close') {
      this.stopVisible = false;
      this.editVisible = false;
      if (type === 'close') {
        this.getWorkFlowList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.workflow-lable {
  width: 68px;
  line-height: 24px;
  text-align: right;
  display: inline-block;
}
.workflow-value {
  line-height: 24px;
  margin-left: 5px;
}
.workflow-stop-button {
  color: #ff4d4f;
}
</style>
